export const enum Anchors {
  CanvasFormHeader = 'CanvasFormHeader',
  CanvasGroupTitlebar = 'CanvasGroupTitlebar',
  CanvasNodeTopLeft = 'CanvasNodeTopLeft',
}
